import { h, defineComponent } from 'vue';
import { NamedLink } from '@/ui/components/navigation/NamedLink';
import { SubscriptionSlugNickName } from '@/entities/subscription/constants';
import { getOrganizationUsersCount } from '@/ui/auth/auth';
import { PlanNickName } from '@/entities/plan/constants';
import { CLICK_EVENTS, ClickProperties, trackClick } from '@/services/activityTracker/activityTrackerHelper';
import { starsIcon } from '@/ui/components/icon/icons';
import { Route } from 'vue-router';
import { useCurrentRoute } from '@/ui/routes';

interface SubscribeButtonProps {
  classes?: string;
  text?: string;
  propertiesEvent?: Partial<ClickProperties>;
}

export const SubscribeButton = defineComponent<SubscribeButtonProps>({
  name: 'SubscribeButton',
  props: ['classes', 'text', 'propertiesEvent'],
  setup(props) {
    return function render() {
      const currentRoute = useCurrentRoute();
      const routeFrozen = currentRoute.value;

      const clickWithTracking = (properties: ClickProperties, currentRouteParam: Route) => {
        trackClick({
          ...CLICK_EVENTS.UPGRADE_BUTTON,
          page: properties.page || currentRouteParam.name!,
          target: properties.target || '',
          label: properties.label || 'upgrade-button',
        });
      };

      return h(NamedLink, {
        class: `button button-upgrade ${props.classes || ''}`,
        props: {
          name: 'subscribe',
          query: {
            plan: SubscriptionSlugNickName.ProfessionalNew,
            users: getOrganizationUsersCount().toString(),
            interval: PlanNickName.Yearly,
          },
        },
        nativeOn: {
          click: () => {
            props.propertiesEvent && clickWithTracking(props.propertiesEvent as ClickProperties, routeFrozen);
          },
        },
      }, [
        starsIcon(),
        props.text,
      ]);
    };
  },
});

export const subscribeButton = (
  {
    classes = '',
    text = '',
    propertiesEvent = undefined,
  }: SubscribeButtonProps,
) => {
  return h(SubscribeButton, { props: { classes, text, propertiesEvent } });
};
